export function gain_produce(pid) {
	if (pid) {

		let temp_produce = false;
		for (let i in produce) {
			if (produce[i]['p_id'] === pid) {
				temp_produce = produce[i];
				break;
			}
		}

		switch (temp_produce['p_id']) {
			//标准宣传单
			case 'pidleaflet_hbxcd': {
				temp_produce['table'] = createPid_hbxcd();
				break;
			}
			//专版宣传单
			case 'pidleaflet_zbxcd': {
				temp_produce['table'] = createPid_zbxcd();
				break;
			}
			//专版海报
			case 'pidleaflet_zbhb': {
				temp_produce['table'] = createPid_zbhb();
				break;
			}
		}

		return temp_produce;
	}
}

const produce = [
	{ p_id: 'pidleaflet_hbxcd', choose: false, p_name: '标准宣传单' },
	{ p_id: 'pidleaflet_zbxcd', choose: false, p_name: '专版宣传单' },
	{ p_id: 'pidleaflet_zbhb', choose: false, p_name: '专版单张' },
]

// 标准宣传单
function createPid_hbxcd() {
	return {
		// 成品尺寸
		p_chengpinchicun: {
			name: '成品尺寸',
			container: ['xx', 'yy', 'chichunstr'],
			data: [
				{
					type: 'select', name: '16开(210*285)A4', value: [210, 285, '16开(210*285)A4'], choose: true, select_show: false, select_data: [
						// {name:'32开(210*140)A5', value:[210, 140, '32开(210×140)A5']},
						{ name: '16开(210*285)A4', value: [210, 285, '16开(210*285)A4'] },
						{ name: '8开(420*285)A3', value: [420, 285, '8开(420*285)A3'] },
						{ name: '4开(420*580)A2', value: [420, 580, '4开(420*580)A2'] },
						{ name: '2开(860*580)A1', value: [860, 580, '2开(860*580)A1'] },
					]
				},
			]
		},
		// 印刷款数
		p_kuanshu: {
			name: '印刷款数',
			container: 'pinzhong',
			data: [
				{ type: 'default', name: '1', value: 1, choose: true, },
				{ type: 'default', name: '2', value: 2, choose: false, },
				{ type: 'default', name: '3', value: 3, choose: false, },
				{ type: 'default', name: '4', value: 4, choose: false, },
				{ type: 'default', name: '5', value: 5, choose: false, },
				{ type: 'default', name: '6', value: 6, choose: false, },
				{ type: 'default', name: '7', value: 7, choose: false, },
				{ type: 'custom1', name: '', value: 9, choose: false, },
			],
		},
		// 印刷数量
		p_yinshuashuliang: {
			name: '印刷数量',
			container: 'shuliang',
			data: [
				{ type: 'default', name: '500', value: 500, choose: true },
				{ type: 'default', name: '1000', value: 1000, choose: false },
				{ type: 'default', name: '2000', value: 2000, choose: false },
				{ type: 'default', name: '3000', value: 3000, choose: false },
				{ type: 'default', name: '5000', value: 5000, choose: false },
				{ type: 'default', name: '10000', value: 10000, choose: false },
				{ type: 'custom1', name: '', value: 20000, choose: false },
			]
		},
		// 单双面
		p_danshuangmian: {
			name: '印刷方式',
			container: 'danshuang',
			data: [
				{ type: 'default', name: '双面', value: '双面', choose: true },
				{ type: 'default', name: '单面', value: '单面', choose: false },
			]
		},
		// 材料
		p_cailiao: {
			name: '材料',
			container: ['cailiao', 'yongzhi'],
			data_multi: [
				{
					type: 'select', name: '双铜纸', value: '双铜纸', choose: true, level: '1', select_show: false, select_data: [
						{ name: '双铜纸', value: '双铜纸' },
						{ name: '双胶纸', value: '双胶纸' },
					]
				},
				{
					type: 'select', name: '200克', value: 200, choose: true, level: '2', select_show: false, select_data: [
						{ name: '200克', value: 200 },
						{ name: '250克', value: 250 },
						{ name: '300克', value: 300 },
					]
				},
			],
			multi_list: [
				// 双铜纸
				[
					{ name: '200克', value: 200 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
				],
				// 双胶纸
				[
					{ name: '80克', value: 80 },
					{ name: '120克', value: 120 },
				],
			]
		},
		// 印刷颜色
		p_yinshuayanse: {
			name: '印刷颜色',
			container: 'ysys',
			data: [
				{ type: 'default', name: '彩色', value: '彩色', choose: true },
			]
		},
		//后道工序
		p_houdaogongxu: {
			name: '后道工序',
			data_after: [
				{
					container: ['hjg'],
					must: true,
					data: [
						{ type: 'default', name: '切成品', value: '切成品', choose: true },
						{ type: 'default', name: '毛料交货', value: '毛料交货', choose: false },
					]
				},

				{ container: '', must: true, data: [] },
				/* {
					container: ['zeye', 'hjg'],
					must: false,
					data: [
						{type:'select',  name:'折页-对折', value:['对折', '折页'], choose:false, select_show:false, select_data:[
							{name:'折页-对折',    value:['对折', '折页']},
							{name:'折页-关门折',  value:['关门折', '折页']},
							{name:'折页-2折3页',  value:['2折3页', '折页']},
							{name:'折页-3折4页',  value:['3折4页', '折页']},
							{name:'折页-4折5页',  value:['4折5页', '折页']},
							{name:'折页-5折以上', value:['5折以上', '折页']},
						]},
					]
				}, */
			]
		}
	}
}

// 专版宣传单
function createPid_zbxcd() {
	return {
		// 成品尺寸
		p_chengpinchicun: {
			name: '成品尺寸',
			container: ['xx', 'yy', 'chichun'],
			data: [
				{
					type: 'select', name: '16开(210*285)A4', value: [210, 285, '210*285'], choose: true, select_show: false, select_data: [
						{ name: '32开(210*140)A5', value: [210, 140, '210*140'] },
						{ name: '16开(210*285)A4', value: [210, 285, '210*285'] },
						{ name: '8开(420*285)A3', value: [420, 285, '420*285'] },
						{ name: '4开(420*580)A2', value: [420, 580, '420*580'] },
						{ name: '2开(860*580)A1', value: [860, 580, '860*580'] },
					]
				},
				{ type: 'custom2', name: '自定义展开尺寸', value: [210, 140, '210*140'], choose: false }
			]
		},
		
		// 单双面
		p_danshuangmian: {
			name: '单双面',
			container: 'danshuang',
			data: [
				{ type: 'default', name: '双面', value: '2', choose: true },
				{ type: 'default', name: '单面', value: '1', choose: false },
			]
		},
		// 材料
		p_cailiao: {
			name: '材料',
			container: ['cailiao', 'yongzhi'],
			data_multi: [
				{
					type: 'select', name: '双铜纸', value: '1', choose: true, level: '1', select_show: false, select_data: [
						{ name: '双铜纸', value: '1' },
						{ name: '单铜纸(白卡)', value: '2' },
						{ name: '哑粉纸', value: '3' },
						{ name: '双胶纸', value: '5' },
						{ name: '灰底白(白板)', value: '6' },
						// { name: '白底白(双白)', value: '7' },
						{ name: '黄牛皮', value: '9' },
						{ name: '白牛皮', value: '14' },
					]
				},
				{
					type: 'select', name: '105克', value: 105, choose: true, level: '2', select_show: false, select_data: [
						{ name: '105克', value: 105 },
						{ name: '128克', value: 128 },
						{ name: '157克', value: 157 },
						{ name: '200克', value: 200 },
						{ name: '230克', value: 230 },
						{ name: '250克', value: 250 },
						{ name: '300克', value: 300 },
						{ name: '350克', value: 350 },
						{ name: '400克', value: 400 },
					]
				},
			],
			multi_list: [
				// 双铜纸
				[
					{ name: '105克', value: 105 },
					{ name: '128克', value: 128 },
					{ name: '157克', value: 157 },
					{ name: '200克', value: 200 },
					{ name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
					{ name: '400克', value: 400 },
				],
				// 单铜纸(白卡)
				[
					{ name: '190克', value: 190 },
					// {name:'200克', value:200},
					{ name: '210克', value: 210 },
					{ name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
					// { name: '400克', value: 400 },
				],
				// 哑粉纸
				[
					{ name: '128克', value: 128 },
					{ name: '157克', value: 157 },
					{ name: '200克', value: 200 },
					{ name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
				],
				// 双胶纸
				[
					{ name: '80克', value: 80 },
					{ name: '100克', value: 100 },
					{ name: '120克', value: 120 },
					{ name: '140克', value: 140 },
					{ name: '160克', value: 160 },
					{ name: '200克', value: 200 },
					{ name: '250克', value: 250 },
				],
				// 灰底白(白板)
				[
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
					{ name: '400克', value: 400 },
					{ name: '450克', value: 450 },
				],
				// 白底白(双白)
				// [
				// 	{ name: '210克', value: 210 },
				// 	{ name: '230克', value: 230 },
				// 	{ name: '250克', value: 250 },
				// 	{ name: '300克', value: 300 },
				// 	{ name: '350克', value: 350 },
				// 	{ name: '400克', value: 400 },
				// 	{ name: '450克', value: 450 },
				// ],
				// 黄牛皮
				[
					{ name: '80克', value: 80 },
					{ name: '100克', value: 100 },
					{ name: '120克', value: 120 },
					{ name: '150克', value: 150 },
					{ name: '160克', value: 160 },
					{ name: '180克', value: 180 },
					{ name: '200克', value: 200 },
					{ name: '250克', value: 250 },
					{ name: '260克', value: 260 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
					{ name: '400克', value: 400 },
				],
				// 白牛皮
				[
					{ name: '100克', value: 100 },
					{ name: '120克', value: 120 },
					{ name: '140克', value: 140 },
					{ name: '150克', value: 150 },
					{ name: '175克', value: 175 },
					{ name: '180克', value: 180 },
					{ name: '200克', value: 200 },
					{ name: '210克', value: 210 },
					{ name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
				],
			]
		},
		// 印刷颜色
		p_yinshuayanse: {
			name: '印刷颜色',
			container: 'ysys',
			data: [
				{ type: 'default', name: '彩色', value: '4', choose: true },
				{ type: 'default', name: '双色', value: '2', choose: false },
				{ type: 'default', name: '单色', value: '1', choose: false },
				// { type: 'default', name: '无', value: '0', choose: false },
			]
		},
		// 印刷数量
		p_yinshuashuliang: {
			name: '印刷数量',
			container: 'shuliang',
			data: [
				{ type: 'default', name: '500', value: 500, choose: true },
				{ type: 'default', name: '1000', value: 1000, choose: false },
				{ type: 'default', name: '2000', value: 2000, choose: false },
				{ type: 'default', name: '3000', value: 3000, choose: false },
				{ type: 'default', name: '5000', value: 5000, choose: false },
				{ type: 'default', name: '10000', value: 10000, choose: false },
				{ type: 'custom1', name: '', value: 20000, choose: false },
			]
		},
		// 自来纸
		/* p_zilaizhi: {
			name: '自来纸',
			container: 'zlz',
			data: [
				{type:'default', name:'否', value:'', choose:true},
				{type:'default', name:'是', value:'1', choose:false},
			]
		}, */
		//后道工序
		p_houdaogongxu: {
			name: '后道工序',
			data_after: [
				{
					container: 'hjg',
					must: false,
					data: [
						{
							type: 'select', name: '单面过光油', value: '单面过光油', choose: false, select_show: false, select_data: [
								{ name: '单面过光油', value: '单面过光油' },
								{ name: '双面过光油', value: '双面过光油' },
								{ name: '单面哑膜', value: '单面覆哑膜' },
								{ name: '双面哑膜', value: '双面覆哑膜' },
								{ name: '单面亮膜', value: '单面覆亮膜' },
								{ name: '双面亮膜', value: '双面覆亮膜' },
							]
						},
					]
				},
				/* {
					container: ['tjx', 'tjy', 'hjg'],
					must: false,
					data: [
						{type:'custom2', name:'烫金', value:[10, 10, '烫金'], choose:false},
					]
				}, */
				{
					container: ['tjx', 'tjy', 'hjg'],
					must: false,
					data: [
						{
							type: 'select', custom2: true, unit: 'mm', name: '烫黄金', value: [10, 10, '烫金/银'], choose: false, select_show: false, select_data: [
								{ name: '烫黄金', value: [10, 10, '烫金/银'] },
								{ name: '烫银', value: [10, 10, '烫金/银'] },
								{ name: '烫红金', value: [10, 10, '烫金/银'] },
								{ name: '烫哑金', value: [10, 10, '烫金/银'] },
								{ name: '烫蓝金', value: [10, 10, '烫金/银'] },
								{ name: '烫黑金', value: [10, 10, '烫金/银'] },
								{ name: '烫指定颜色金', value: [10, 10, '烫金/银'] },
							]
						},
					]
				},
				{
					container: 'hjg',
					must: false,
					data: [
						{ type: 'default', name: '压纹', value: '压纹', choose: false },
					]
				},
				{
					container: ['byx', 'hjg'],
					must: false,
					data: [
						{
							type: 'select', name: '模切||啤异型-简单边框', value: ['1', '模切'], choose: false, select_show: false, select_data: [
								{ name: '模切||啤异型-简单边框', value: ['1', '模切'] },
								{ name: '模切||啤异型-盒型吊牌', value: ['2', '模切'] },
								{ name: '模切||啤异型-复杂形态', value: ['3', '模切'] },
							]
						},
					]
				},
				{
					container: ['zeye', 'hjg'],
					must: false,
					data: [
						{
							type: 'select', name: '折页-对折', value: ['对折', '折页'], choose: false, select_show: false, select_data: [
								{ name: '折页-对折', value: ['对折', '折页'] },
								{ name: '折页-关门折', value: ['关门折', '折页'] },
								{ name: '折页-2折3页', value: ['2折3页', '折页'] },
								{ name: '折页-3折4页', value: ['3折4页', '折页'] },
								{ name: '折页-4折5页', value: ['4折5页', '折页'] },
								{ name: '折页-5折以上', value: ['5折以上', '折页'] },
							]
						},
					]
				},
				{
					container: ['uvx', 'uvy', 'hjg'],
					must: false,
					data: [
						{ type: 'custom2', name: '局部UV', value: [10, 10, '局部UV'], choose: false },
					]
				},
				{
					container: ['jtx', 'jty', 'hjg'],
					must: false,
					data: [
						{ type: 'custom2', name: '击凸', value: [10, 10, '击凸'], choose: false },
					]
				},
				{
					container: ['hjg', 'hjghmgs', 'hmjls'],
					must: false,
					data: [
						{
							type: 'select', name: '打号码-1个', value: ['打号码', '1', ''], choose: false, select_show: false, select_data: [
								{ name: '打号码-1个', value: ['打号码', '1', ''] },
								{ name: '打号码-2个-超过3cm', value: ['打号码', '2', '0'] },
								{ name: '打号码-2个-不超过3cm', value: ['打号码', '2', '1'] },
								{ name: '打号码-3个', value: ['打号码', '3', ''] },
							]
						},
					]
				},
				{
					container: ['jidaohen', 'yhlx', 'hjg'],
					must: false,
					data: [
						{ type: 'custom1', name: '压痕压点线-压痕不折', value: [1, '压痕不折', '压痕压点线'], unit: '道', choose: false },
						{ type: 'custom1', name: '压痕压点线-压痕折', value: [1, '压痕折', '压痕压点线'], unit: '道', choose: false }
					]
				},
			]
		}
	}
}

// 专版海报
function createPid_zbhb() {
	return {
		// 成品尺寸
		p_chengpinchicun: {
			name: '成品尺寸',
			container: ['xx', 'yy', 'chichun'],
			data: [
				{
					type: 'select', name: '正度32开(185*125)', value: [185, 125, '185*125'], choose: true, select_show: false, select_data: [
						{ name: '正度32开(185*125)', value: [185, 125, '185*125'] },
						{ name: '正度16开(260*185)', value: [260, 185, '260*185'] },
						{ name: '正度8开(260*380)', value: [260, 380, '260*380'] },
						{ name: '正度4开(530*380)', value: [530, 380, '530*380'] },
						{ name: '正度2开(530*760)', value: [530, 760, '530*760'] },
					]
				},
				{ type: 'custom2', name: '自定义展开尺寸', value: [530, 760, '530*760'], choose: false }
			]
		},
		// 印刷数量
		p_yinshuashuliang: {
			name: '印刷数量',
			container: 'shuliang',
			data: [
				{ type: 'custom1', name: '', value: 1000, choose: true },
			]
		},
		// 单双面
		p_danshuangmian: {
			name: '单双面',
			container: 'danshuang',
			data: [
				{ type: 'default', name: '单面', value: '1', choose: true },
				{ type: 'default', name: '双面', value: '2', choose: false },
			]
		},
		// 材料
		p_cailiao: {
			name: '材料',
			container: ['cailiao', 'yongzhi'],
			data_multi: [
				{
					type: 'select', name: '双铜纸', value: '1', choose: true, level: '1', select_show: false, select_data: [
						{ name: '双铜纸', value: '1' },
						{ name: '单铜纸(白卡)', value: '2' },
						{ name: '哑粉纸', value: '3' },
						{ name: '双胶纸', value: '5' },
						{ name: '灰底白(白板)', value: '6' },
						{ name: '白底白(双白)', value: '7' },
						{ name: '黄牛皮', value: '9' },
						{ name: '白牛皮', value: '14' },
					]
				},
				{
					type: 'select', name: '80克', value: 80, choose: true, level: '2', select_show: false, select_data: [
						{ name: '80克', value: 80 },
						{ name: '105克', value: 105 },
						{ name: '120克', value: 120 },
						{ name: '128克', value: 128 },
						{ name: '140克', value: 140 },
						{ name: '150克', value: 150 },
						{ name: '200克', value: 200 },
						{ name: '230克', value: 230 },
						{ name: '250克', value: 250 },
						{ name: '300克', value: 300 },
						{ name: '350克', value: 350 },
						{ name: '400克', value: 400 },
					]
				},
			],
			multi_list: [
				// 双铜纸
				[
					{ name: '80克', value: 80 },
					{ name: '105克', value: 105 },
					{ name: '120克', value: 120 },
					{ name: '128克', value: 128 },
					{ name: '140克', value: 140 },
					{ name: '150克', value: 150 },
					{ name: '200克', value: 200 },
					{ name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
					{ name: '400克', value: 400 },
				],
				// 单铜纸(白卡)
				[
					{ name: '190克', value: 190 },
					// {name:'200克', value:200},
					{ name: '210克', value: 210 },
					{ name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
					{ name: '400克', value: 400 },
				],
				// 哑粉纸
				[
					{ name: '105克', value: 105 },
					{ name: '128克', value: 128 },
					{ name: '157克', value: 157 },
					{ name: '200克', value: 200 },
					{ name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
					{ name: '400克', value: 400 },
				],
				// 双胶纸
				[
					{ name: '55克', value: 55 },
					{ name: '60克', value: 60 },
					{ name: '70克', value: 70 },
					{ name: '80克', value: 80 },
					{ name: '100克', value: 100 },
					{ name: '120克', value: 120 },
					{ name: '140克', value: 140 },
					{ name: '160克', value: 160 },
					{ name: '200克', value: 200 },
					{ name: '250克', value: 250 },
				],
				// 灰底白(白板)
				[
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
					{ name: '400克', value: 400 },
					{ name: '450克', value: 450 },
				],
				// 白底白(双白)
				[
					{ name: '210克', value: 210 },
					{ name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
					{ name: '400克', value: 400 },
					{ name: '450克', value: 450 },
				],
				// 黄牛皮
				[
					{ name: '60克', value: 60 },
					{ name: '70克', value: 70 },
					{ name: '80克', value: 80 },
					{ name: '100克', value: 100 },
					{ name: '120克', value: 120 },
					{ name: '130克', value: 130 },
					{ name: '140克', value: 140 },
					{ name: '150克', value: 150 },
					{ name: '160克', value: 160 },
					{ name: '180克', value: 180 },
					{ name: '200克', value: 200 },
					{ name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '260克', value: 260 },
					{ name: '300克', value: 300 },
					{ name: '310克', value: 310 },
					{ name: '350克', value: 350 },
					{ name: '360克', value: 360 },
					{ name: '400克', value: 400 },
					{ name: '410克', value: 410 },
					{ name: '450克', value: 450 },
				],
				// 白牛皮
				[
					{ name: '80克', value: 80 },
					{ name: '100克', value: 100 },
					{ name: '120克', value: 120 },
					{ name: '140克', value: 140 },
					{ name: '150克', value: 150 },
					{ name: '175克', value: 175 },
					{ name: '180克', value: 180 },
					{ name: '200克', value: 200 },
					{ name: '210克', value: 210 },
					{ name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
				],
			]
		},
		// 印刷颜色
		p_yinshuayanse: {
			name: '印刷颜色',
			container: 'ysys',
			data: [
				{ type: 'default', name: '彩色', value: '4', choose: true },
				{ type: 'default', name: '双色', value: '2', choose: false },
				{ type: 'default', name: '单色', value: '1', choose: false },
				{ type: 'default', name: '无', value: '0', choose: false },
			]
		},
		//后道工序
		p_houdaogongxu: {
			name: '后道工序',
			data_after: [
				{
					container: 'hjg',
					must: true,
					data: [
						{ type: 'default', name: '切成品', value: '切成品', choose: true },
						{ type: 'default', name: '毛料交货', value: '毛料交货', choose: false },
					]
				},
				{ container: '', must: true, data: [] },
				{
					container: 'hjg',
					must: false,
					data: [
						{ type: 'default', name: '单面过光油', value: '单面过光油', choose: false },
					]
				},
				{
					container: ['tjx', 'tjy', 'hjg'],
					must: false,
					data: [
						{
							type: 'select', custom2: true, unit: 'mm', name: '烫黄金', value: [10, 10, '烫金/银'], choose: false, select_show: false, select_data: [
								{ name: '烫黄金', value: [10, 10, '烫金/银'] },
								{ name: '烫银', value: [10, 10, '烫金/银'] },
								{ name: '烫红金', value: [10, 10, '烫金/银'] },
								{ name: '烫哑金', value: [10, 10, '烫金/银'] },
								{ name: '烫蓝金', value: [10, 10, '烫金/银'] },
								{ name: '烫黑金', value: [10, 10, '烫金/银'] },
								{ name: '烫指定颜色金', value: [10, 10, '烫金/银'] },
							]
						},
					]
				},
				{ container: '', must: true, data: [] },
				{
					container: ['byx', 'hjg'],
					must: false,
					data: [
						{
							type: 'select', name: '模切||啤异型-简单边框', value: '?', choose: false, select_show: false, select_data: [
								{ name: '模切||啤异型-简单边框', value: ['1', '模切'] },
								{ name: '模切||啤异型-盒型吊牌', value: ['2', '模切'] },
								{ name: '模切||啤异型-复杂形态', value: ['3', '模切'] },
							]
						},
					]
				},
			]
		}
	}
}



// WEBPACK FOOTER //
// ./src/seal/proLeaflet.js